import { default as CheckboxComponent } from "./checkbox.js";
import CheckboxGroup from "./checkbox-group.js";
const Checkbox = CheckboxComponent;
Checkbox.Group = CheckboxGroup;
export default Checkbox;
